import React,{useEffect} from "react";
import styled from '@emotion/styled'

const DividerContainer = styled.div({
    display: "flex",
    alignItems: "center"
});
const DividerBorder= styled.div(props => ({
    borderBottom: "2px solid",
    width: "100%",
    borderColor: props.color,
    display:props.position && "none"
}));
const DividerContent= styled.span(props=>({
    paddingTop: 5,
    paddingBottom: 5,
    paddingRight: 20,
    paddingLeft: 20,
    fontWeight: 500,
    fontSize: props.fontSize,
    color: props.color
  }));


const DividerWithText = ({ children, color, fontSize, right=false, left=false }) =>{
    useEffect(() => {}, [right,left])
      
    return(
    <DividerContainer>
        <DividerBorder position={left} color={color}/>
            <DividerContent fontSize={fontSize} color={color}>{children}</DividerContent>
        <DividerBorder position={right} color={color} />
    </DividerContainer>
    )};

export default DividerWithText;